import React from 'react';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import TextFieldResizable from '../../../../components/form/text-field-resizable';

const AdditionalInformation = (props) => {
  const {
    authorableContent: {
      title,
      formFields: {
        comments: {
          label,
          placeholder,
        },
      },
    },
    handleOnBlur,
    handleOnChange,
    additionalInfoCommentsValue,
  } = props;

  return (
    <React.Fragment>
      <SummaryDetails summaryTitle={title} />
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <TextFieldResizable
            label={label}
            id="additionalInfoComments"
            placeholder={placeholder}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            value={additionalInfoCommentsValue}
            rows={6}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdditionalInformation;
